import { Input } from '@ui'
import React, { FC } from 'react'
import { HiMagnifyingGlass } from 'react-icons/hi2'

interface Props {
  searchTerm: string
  setSearchTerm: (value: string) => void
  placeholder: string
  autoFocus?: boolean
}

const SearchBar: FC<Props> = ({ searchTerm, setSearchTerm, placeholder, autoFocus }) => (
  <Input
    type="search"
    aria-label={placeholder}
    leading={<HiMagnifyingGlass className="size-[18px]" />}
    value={searchTerm}
    onChange={({ target: { value } }) => setSearchTerm(value)}
    placeholder={placeholder}
    autoFocus={!!autoFocus}
  />
)

export default SearchBar
